var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgXml = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0483 11.9723L13.422 13.9936H15.294L13.0992 10.7695L15.1554 7.5H13.357L12.2065 9.45649L10.8697 7.5H8.99983L11.147 10.6507L9.06267 13.9936H10.8697L12.0483 11.9723Z",
    fill: "#9747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2283 7.5453V13.9935H21.651V9.96824L20.2513 14H18.8863L17.478 9.9596V14H15.9006V7.55178H17.8268L19.5883 12.0435L21.3108 7.55178L23.2283 7.5453Z",
    fill: "#9747FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9928 12.7907H25.8911L25.8868 7.5H24.3095V13.9936H27.9928V12.7907Z",
    fill: "#9747FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXml);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/xml.3800883f9f0bdcc1e6ab08b878b0b60e.svg";